import { Injectable } from '@angular/core';
import { LocaleService } from 'src/app/shared/service/locale.service';

export type KYCResponseType = {
  primaryVerificationStatus: string;
  intermediateVerificationStatus: string;
  advancedVerificationStatus: string;
  primaryVerificationTime: string | null;
  intermediateVerificationTime: string | null;
  advancedVerificationTime: string | null;
};

// kyc页面UI显示文案
const CARD_INFO_CONFIG: any = [
  {
    // 基础认证
    id: 0,
    header: 'basic_ver',
    discrible: 'simple_fast',
    status: 'I',
    time: null,
    cardInfor: [
      { value: 'review_time_one', icon: 'time' },
      { value: 'personal_info', icon: 'edit-simple' },
    ],
    acInforConfig: {
      fiatDepositLimit: '',
      fiatToVirtualLimit: '',
      fiatWithdrawLimit: '',
      virtualDepositLimit: '',
      virtualWithdrawLimit: '',
    },
  },
  {
    // 中级认证
    id: 1,
    header: 'inter_ceri',
    discrible: 'most_choose',
    status: 'U',
    time: null,
    cardInfor: [
      { value: 'review_t_five', icon: 'time' },
      { value: 'basic_ver_req', icon: 'basic' },
      { value: 'gov_id', icon: 'ic' },
      // { value: '银行卡', icon: 'bankcard' },
      // { value: '手机号', icon: 'phone' },
      // { value: '人脸识别认证', icon: 'face' },
    ],
    acInforConfig: {
      fiatDepositLimit: '',
      fiatToVirtualLimit: '',
      fiatWithdrawLimit: '',
      virtualDepositLimit: '',
      virtualWithdrawLimit: '',
    },
  },
  {
    //高级认证
    id: 2,
    header: 'ad_ceri',
    discrible: 'max_fiat_amount',
    status: 'U',
    time: null,
    cardInfor: [
      { value: 'review_t_ten', icon: 'time' },
      { value: 'inter_require', icon: 'shield3' },
      { value: 'add_ver', icon: 'location' },
    ],
    acInforConfig: {
      fiatDepositLimit: '',
      fiatToVirtualLimit: '',
      fiatWithdrawLimit: '',
      virtualDepositLimit: '',
      virtualWithdrawLimit: '',
    },
  },
];

@Injectable({
  providedIn: 'root',
})
export class KycUtils {
  constructor(private localeService: LocaleService) {}
  getCardInfoConfig() {
    const config1 = { ...CARD_INFO_CONFIG[0] },
      config2 = { ...CARD_INFO_CONFIG[1] },
      config3 = { ...CARD_INFO_CONFIG[2] };
    return [config1, config2, config3];
    // return newRef;
  }

  public NOTICE_CONTANTS = {
    primary: [
      { header: this.localeService.getValue('buy_cr_fiat'), text: ['$1000 ' + this.localeService.getValue('lifel00')] },
      { header: this.localeService.getValue('dep_with00'), text: ['$1000 ' + this.localeService.getValue('lifel00')] },
      { header: this.localeService.getValue('crypt_lim00'), text: ['50K USDT'] },
    ],
    intermediate: [
      {
        header: this.localeService.getValue('buy_cr_fiat'),
        text: ['$50K ' + this.localeService.getValue('day00'), '$500K ' + this.localeService.getValue('mon00')],
      },
      {
        header: this.localeService.getValue('dep_with00'),
        text: ['$10K ' + this.localeService.getValue('day00'), '$100K ' + this.localeService.getValue('mon00')],
      },
      { header: this.localeService.getValue('crypt_lim00'), text: ['5M USDT'] },
    ],
    advance: [
      {
        header: this.localeService.getValue('buy_cr_fiat'),
        text: ['$50K ' + this.localeService.getValue('day00'), '$500K ' + this.localeService.getValue('mon00')],
      },
      {
        header: this.localeService.getValue('dep_with00'),
        text: ['$10K' + this.localeService.getValue('day00'), '$100K ' + this.localeService.getValue('mon00')],
      },
      { header: this.localeService.getValue('crypt_lim00'), text: ['5M USDT'] },
    ],
  };

  // 模拟后台api返回的用户当前认证权限信息
  public kycQueryResponse: KYCResponseType = {
    primaryVerificationStatus: 'S',
    intermediateVerificationStatus: 'I',
    advancedVerificationStatus: 'I',
    primaryVerificationTime: null,
    intermediateVerificationTime: null,
    advancedVerificationTime: null,
  };

  //模拟后台api返回 用户身份证号信息
  public userIcNumberQueryResponse = {
    isExisted: true,
    icNumber: '50010720110101701',
  };
}
